import { baseService } from './baseService'
import { STATUS_CODE } from '../data/system_settings'

class GetListAdmin extends baseService {
  baseUrl = 'admin/all'

  async getAll() {
    try {
      const res = await this.get(this.baseUrl)
      if (res.status === STATUS_CODE.SUCCESS) return res
      else {
        throw new Error('Lấy danh sách Admin thất bại')
      }
    } catch (error) {
      throw error
    }
  }
}

export const getListAdmin = new GetListAdmin()
